import angular from 'angular';
import collapse from 'angular-ui-bootstrap/src/collapse';
import dropdown from 'angular-ui-bootstrap/src/dropdown';
import modal from 'angular-ui-bootstrap/src/modal';
import typeahead from 'angular-ui-bootstrap/src/typeahead';
import accordion from 'angular-ui-bootstrap/src/accordion';
import tabs from 'angular-ui-bootstrap/src/tabs';

// Définition du module 'app', module central de l'application
angular
    .module('epdf-app', [
        'ngResource',
        'ngAnimate',
        'ngMessages',
        'ngSanitize',
        'ui.router',
        collapse,
        dropdown,
        modal,
        typeahead,
        accordion,
        tabs,
        'ui.grid',
        'ui.grid.autoResize',
        'ui.grid.i18n',
        'ui.grid.resizeColumns',
        'ui.grid.moveColumns',
        'ui.grid.selection',
        'ui.grid.pagination',
        'ui.grid.exporter',
        'toastr',
        'mgcrea.ngStrap.tooltip',
        'mgcrea.ngStrap.datepicker',
        'mgcrea.ngStrap.timepicker',
        'mgcrea.ngStrap.helpers.dateParser',
        'pascalprecht.translate',
        'ngStorage',
        'ngFileUpload',
        'pdf',
        'app',
        'home',
        'dashboard',
        'envelope',
        'folder',
        'batch',
        'message',
        'principal',
        'depositor',
        'company',
        'container',
        'ladProvider',
        'dematPlatform',
        'rebroadcast',
        'resumption',
        'epdf.admin.activities',
        'lad-mock',
        'evl-waiting',
        'indexfile',
        'processdelay',
        'depositorconfirm'
    ])
    .run([
        '$rootScope',
        '$window',
        function($rootScope, $window) {
            $rootScope.$back = function() {
                $window.history.back();
            };
        }
    ]);
